/*
  site-cart (<site-cart>): el header de BFCM, literal del artifact Bundle Store PDP. Lo carga snippets/site-cart.liquid:
  el elemento es la parte de arriba (franja, ahorro, escalera, vacío) y vive debajo de la fila de íconos de
  sections/u1-navbar.liquid; los productos y el resumen ([data-site-cart-panel]) van en el overlay del carrito de la
  misma pastilla.
  · La navbar sigue manejando abrir y cerrar (bolsa, fondo, Escape, scroll lock); acá se mira su pastilla
    (data-u1-nav-open y data-u1-nav-overlay-type) para saber si el carrito está a la vista, y se le pone sc-has-items
    para que el CSS no abra el cuerpo del carrito cuando está vacío. La franja cerrada ([data-site-cart-strip]) abre
    el carrito con la bolsa de la navbar; "Continue shopping" cierra con su fondo.
  · Fuente de verdad: /cart.js. Se vuelve a pedir con cada cart:update o cart:change de otros (PDP, Flash Deals, la
    navbar). Lo que se cambia acá va por /cart/change.js con el line key y avisa con cart:update (sourceId 'site-cart'),
    así la navbar corre sus reglas de siempre (regalo, códigos de packs, FREE REPLACEMENT) y actualiza la bolsa.
  · Escalera: [monto mínimo, % off] en la moneda del mercado. El escalón y lo que falta para el próximo salen del
    subtotal ANTES de cualquier descuento (original_line_price de cada línea; el regalo cuenta lo que paga, 0): los
    descuentos por monto pueden ser de producto (BFCM-MX-*: "Amount off product"), y esos ya vienen restados en
    items_subtotal_price, así que con ese el escalón bajaría apenas Shopify aplica el descuento. Entre dos escalones
    la barra avanza en proporción al monto que hay entre uno y otro (cada tramo mide lo mismo aunque cubra distinta
    plata). El ahorro del resumen es el que aplicó Shopify (subtotal menos total_price: descuentos de producto y de
    pedido, sin el valor del regalo); si todavía no aplicó ninguno (por ejemplo, el descuento automático no está creado
    en ese mercado), se muestra el estimado con el % del escalón y el resumen lo marca con data-estimated.
  · Cuando sube el escalón: el % salta (pop) y, con el carrito abierto, cae confetti en toda la nav y se apoya sobre la
    pastilla del ahorro.
  · Escalones superados (uno más alto ya rige): tachados. El actual, más grande y con brillo, destellos y partículas
    que suben (.sc-fx, se muda al escalón actual; lo anima el CSS).
  · Envío gratis, un hito más de la misma barra: el umbral es el de Rebuy, que calcula la navbar y deja en
    data-threshold de su barra de envío (que ya no se ve: la mudamos al resumen y el CSS la oculta). Se arma la celda
    con el camión (template [data-sc-ship-tpl]) en su lugar por monto, entre los escalones; la barra avanza por todos
    los hitos (cada tramo mide lo mismo). Abajo dice el monto y, alcanzado, "Free shipping". El mensaje de arriba suma
    lo que falta para el envío gratis o que ya lo tenés.
  · Lo de siempre del carrito sigue en manos del JS de la navbar: acá solo se mudan a este carrito sus nodos de la barra de
    envío gratis y de las recomendaciones de Rebuy (la navbar guarda referencias a esos nodos y sus botones llevan sus
    propios listeners, así que siguen andando donde estén). El regalo (Rebuy o Flash deal) es una línea sin cantidad,
    FREE cuando Shopify ya lo dejó en 0. Sacar un componente de un pack (_u1_bundle) saca el código de descuento, igual
    que en el carrito de siempre. El countdown de campaña corre en la franja.
  · Sin escalera (data-plain, la A): no hay franja del ahorro, encabezado, escalera ni confetti; solo productos, resumen
    y vacío. El ahorro del resumen es solo el que aplicó Shopify (sin estimado) y su fila se esconde si no hay.
  Con "reducir movimiento" no hay confetti ni scroll animado.
*/
const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
const CELL = 147; /* igual que --sc-cell */
const $$ = (sel, root) => [...root.querySelectorAll(sel)];
const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
const MINUS = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M3 7h8"/></svg>';
const PLUS = '<svg viewBox="0 0 14 14" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" aria-hidden="true"><path d="M3 7h8M7 3v8"/></svg>';
const TRASH = '<svg width="16" height="16" viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M2.5 4h11M6 4V2.5h4V4M4 4l.7 9.5h6.6L12 4"/></svg>';
/* destellos alrededor del % del escalón actual: [x, y, tamaño, demora s], desde el centro del % */
const SPARKS = [[-40, -8, 1, 0], [36, -12, .8, .8], [46, 7, .6, 1.5], [-31, 11, .65, 2.1], [4, -18, .55, 1.2]];
/* partículas que suben desde el monto: [x, deriva, demora s, duración s] */
const MOTES = [[-30, 6, 0, 2.4], [-14, -4, .9, 2.8], [2, 5, .4, 2.2], [18, -6, 1.6, 2.6], [32, 3, 1.1, 3], [-22, 8, 2.1, 2.5], [10, -3, 2.6, 2.3], [26, 7, .2, 2.9]];
const pad = n => String(n).padStart(2, '0');
const esc = s => String(s == null ? '' : s).replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

class SiteCart extends HTMLElement {
  connectedCallback() {
    if (this._ready) return;
    this._ready = true;
    const cfg = JSON.parse(this.querySelector('[data-site-cart-config]').textContent);
    this.plain = this.hasAttribute('data-plain');
    this.tiers = this.plain ? [] : cfg.tiers.map(([min, pct]) => [Math.round(min * 100), pct]).sort((a, b) => a[0] - b[0]);
    this.pct = null;
    this.cart = null;
    this.pill = this.closest('[data-u1-nav-pill]');
    this.navbar = this.closest('[data-u1-navbar]');
    this.strip = this.querySelector('[data-site-cart-strip]');
    this.panel = (this.pill && this.pill.querySelector('[data-site-cart-panel]')) || document.createElement('div');
    this.track = this.querySelector('[data-sc-track]');
    this.adoptLegacy();
    this.initShip();
    this.initCountdown();
    this.initOpenState();
    this.initTrack();
    this.initActions();
    this.drawEmpty();
    this.confetti = this.hasAttribute('data-confetti') && this.pill ? makeConfetti(this.pill, this.querySelector('[data-sc-confetti]'), () => this.panel.querySelector('[data-sc-save]')) : null;
    this._onCart = e => {
      const src = e.detail && e.detail.sourceId;
      if (src === 'site-cart') return;
      /* si el evento ya trae el carrito completo (Horizon, la navbar), no hace falta pedirlo */
      const res = e.detail && e.detail.resource;
      if (res && Array.isArray(res.items) && 'items_subtotal_price' in res) this.render(res);
      else this.refresh();
    };
    document.addEventListener('cart:update', this._onCart);
    document.addEventListener('cart:change', this._onCart);
    this.refresh();
  }

  disconnectedCallback() {
    document.removeEventListener('cart:update', this._onCart);
    document.removeEventListener('cart:change', this._onCart);
    if (this._mo) this._mo.disconnect();
    if (this._shipMo) this._shipMo.disconnect();
    clearInterval(this._cdT);
    this._ready = false;
  }

  /* ───────── Lo de siempre: envío gratis y recomendaciones de Rebuy, del carrito de la navbar a este ───────── */
  adoptLegacy() {
    if (!this.pill) return;
    [['[data-u1-nav-cart-progress]', 'ship'], ['[data-u1-nav-cart-upsells]', 'upsells']].forEach(([sel, name]) => {
      const node = this.pill.querySelector(sel);
      const slot = this.panel.querySelector(`[data-sc-slot="${name}"]`);
      if (node && slot && !slot.contains(node)) slot.append(node);
    });
  }

  /* ───────── Envío gratis: un hito de la escalera ───────── */
  initShip() {
    this.ship = 0;
    const node = this.panel.querySelector('[data-u1-nav-cart-progress]');
    if (!node) return;
    const read = () => {
      const v = Number(node.dataset.threshold) || 0;
      if (v === this.ship) return;
      this.ship = v;
      this.placeShip();
      if (this.cart) this.render(this.cart);
    };
    this._shipMo = new MutationObserver(read);
    this._shipMo.observe(node, { attributes: true, attributeFilter: ['data-threshold'] });
    read();
  }

  /* la celda del camión entre los escalones, por monto; las marcas de la barra, una por celda */
  placeShip() {
    const cellsEl = this.querySelector('.sc-cells');
    const tpl = this.querySelector('[data-sc-ship-tpl]');
    if (!cellsEl || !tpl) return;
    const old = cellsEl.querySelector('[data-sc-ship]');
    if (old) old.remove();
    if (this.ship) {
      const cell = tpl.content.firstElementChild.cloneNode(true);
      const tierCells = $$('.sc-cell', cellsEl);
      const at = this.tiers.findIndex(([min]) => min > this.ship);
      cellsEl.insertBefore(cell, at < 0 ? null : tierCells[at] || null);
    }
    const n = cellsEl.children.length;
    const inner = this.querySelector('.sc-track-in');
    if (inner) inner.style.setProperty('--n', n);
    const line = this.querySelector('.sc-tline');
    $$('.sc-ms', line).forEach(m => m.remove());
    for (let i = 0; i < n; i++) {
      const m = document.createElement('span');
      m.className = 'sc-ms';
      m.style.left = `calc(26px + (${i} + .5) * var(--sc-cell))`;
      line.append(m);
    }
  }

  /* dónde va la barra con todos los hitos (escalones y envío gratis): i, el último alcanzado; frac, el avance al próximo */
  ladder(sub, count) {
    const mins = this.tiers.map(([min]) => min);
    if (this.ship) mins.push(this.ship);
    mins.sort((a, b) => a - b);
    let i = -1;
    if (count) mins.forEach((m, k) => { if (sub >= m) i = k; });
    const next = mins[i + 1];
    const from = i < 0 ? 0 : mins[i];
    const frac = next == null ? 1 : Math.min(1, Math.max(0, (sub - from) / Math.max(next - from, 1)));
    return { i, done: next == null, frac };
  }

  /* los destellos y partículas del escalón actual (una vez; se mudan de celda) */
  fx() {
    if (!this._fx) {
      const el = document.createElement('span');
      el.className = 'sc-fx';
      el.setAttribute('aria-hidden', 'true');
      el.innerHTML = '<i class="sc-glow"></i>' +
        SPARKS.map(([x, y, s, d]) => `<i class="sc-spk" style="--x: ${x}px; --y: ${y}px; --s: ${s}; --d: ${d}s"></i>`).join('') +
        MOTES.map(([x, dx, d, t]) => `<i class="sc-mote" style="--x: ${x}px; --dx: ${dx}px; --d: ${d}s; --t: ${t}s"></i>`).join('');
      this._fx = el;
    }
    return this._fx;
  }

  /* ───────── Countdown de campaña en la franja ───────── */
  initCountdown() {
    const el = this.querySelector('[data-sc-end]');
    if (!el) return;
    const end = Date.parse(el.dataset.scEnd);
    if (Number.isNaN(end)) return;
    const tick = () => {
      const ms = end - Date.now();
      if (ms <= 0) { el.hidden = true; clearInterval(this._cdT); return; }
      const r = Math.floor(ms / 1000), d = Math.floor(r / 86400);
      el.textContent = `${d ? `${d}d ` : ''}${pad(Math.floor(r / 3600) % 24)}:${pad(Math.floor(r / 60) % 60)}:${pad(r % 60)}`;
      el.hidden = false;
    };
    tick();
    this._cdT = setInterval(tick, 1000);
  }

  /* ───────── Abierto / cerrado: lo maneja la navbar ───────── */
  initOpenState() {
    if (!this.pill) return;
    const sync = () => {
      const open = this.pill.dataset.u1NavOpen === 'true' && this.pill.dataset.u1NavOverlayType === 'cart';
      if (open === this.open) return;
      this.open = open;
      if (this.strip) this.strip.setAttribute('aria-expanded', String(open));
      if (open) {
        this._openedAt = performance.now();
        /* después de crecer, la escalera recentra el escalón actual */
        setTimeout(() => { this.scrollTrack(true); this.updateFades(); }, 480);
      } else if (this.confetti) this.confetti.stop();
    };
    this._mo = new MutationObserver(sync);
    this._mo.observe(this.pill, { attributes: true, attributeFilter: ['data-u1-nav-open', 'data-u1-nav-overlay-type'] });
    sync();
  }

  openCart() {
    const bag = this.navbar && this.navbar.querySelector('[data-u1-nav-cart]');
    if (bag && !this.open) bag.click();
  }

  closeCart() {
    const backdrop = document.querySelector('[data-u1-nav-backdrop]');
    if (backdrop && this.open) backdrop.click();
  }

  initActions() {
    if (this.strip) this.strip.addEventListener('click', e => { this.openCart(); if (e.detail) e.currentTarget.blur(); });
    [...$$('[data-sc-close]', this), ...$$('[data-sc-close]', this.panel)].forEach(b => b.addEventListener('click', () => this.closeCart()));
    const lines = this.panel.querySelector('[data-sc-lines]');
    if (lines) lines.addEventListener('click', e => {
      const row = e.target.closest('[data-key]');
      if (!row || row.classList.contains('is-busy')) return;
      const qty = Number(row.dataset.qty);
      if (e.target.closest('[data-sc-del]')) this.change(row, 0);
      else {
        const q = e.target.closest('[data-sc-q]');
        if (q) this.change(row, Math.max(0, qty + Number(q.dataset.scQ)));
      }
    });
  }

  /* ───────── Escalera: scroll al escalón actual, chevrones y arrastre con el mouse ───────── */
  initTrack() {
    const tr = this.track;
    if (!tr) return;
    tr.addEventListener('scroll', () => this.updateFades(), { passive: true });
    $$('[data-sc-tnav]', this).forEach(b => b.addEventListener('click', e => {
      tr.scrollBy({ left: Number(b.dataset.scTnav) * CELL * 2, behavior: reduce.matches ? 'auto' : 'smooth' });
      if (e.detail) e.currentTarget.blur();
    }));
    let sx = 0, sl = 0, down = false;
    tr.addEventListener('pointerdown', e => {
      if (e.pointerType !== 'mouse') return;
      down = true; sx = e.clientX; sl = tr.scrollLeft;
      tr.setPointerCapture(e.pointerId);
      tr.classList.add('is-dragging');
    });
    tr.addEventListener('pointermove', e => { if (down) tr.scrollLeft = sl - (e.clientX - sx); });
    const up = () => { down = false; tr.classList.remove('is-dragging'); };
    tr.addEventListener('pointerup', up);
    tr.addEventListener('pointercancel', up);
    if ('ResizeObserver' in window) new ResizeObserver(() => this.updateFades()).observe(tr);
  }

  scrollTrack(instant) {
    if (!this.track) return;
    /* la celda del escalón actual (con el envío gratis en el medio, ya no coincide con el número de escalón) */
    const cells = $$('.sc-cell', this);
    const at = Math.max(0, cells.findIndex(c => c.classList.contains('is-cur')));
    const x = 26 + (at + .5) * CELL - this.track.clientWidth * .38;
    this.track.scrollTo({ left: Math.max(0, x), behavior: instant || reduce.matches ? 'auto' : 'smooth' });
  }

  updateFades() {
    if (!this.track) return;
    const tr = this.track, max = tr.scrollWidth - tr.clientWidth;
    this.querySelector('[data-sc-fade="-1"]').classList.toggle('is-off', tr.scrollLeft < 4);
    this.querySelector('[data-sc-fade="1"]').classList.toggle('is-off', tr.scrollLeft > max - 4);
  }

  /* ───────── Carrito ───────── */
  async refresh() {
    if (this._inflight) { this._again = true; return; }
    this._inflight = true;
    try {
      const res = await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' });
      this.render(await res.json());
    } catch (err) {
      console.error('[site-cart]', err);
    } finally {
      this._inflight = false;
      if (this._again) { this._again = false; this.refresh(); }
    }
  }

  async change(row, quantity) {
    row.classList.add('is-busy');
    try {
      const res = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: row.dataset.key, quantity }),
      });
      let cart = await res.json();
      if (!res.ok || cart.status) throw new Error(cart.description || cart.message || 'Could not update the cart');
      if (quantity === 0 && row.hasAttribute('data-bundle')) {
        /* sacar un componente rompe el pack: se saca el código del pack, como en el carrito de siempre, pero no los de
           regalo (_u1_flash_codes, "CODIGO@producto"): esos los saca la navbar (guardFlashRemoteCode) solo si ya no está
           su producto, así el regalo de otro casco no pasa a cobrarse */
        const now = await (await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })).json();
        const flash = String((now.attributes && now.attributes._u1_flash_codes) || '').split(',').map(s => s.split('@')[0].trim().toUpperCase()).filter(Boolean);
        const keep = (now.discount_codes || []).map(d => String(d.code || '')).filter(c => flash.indexOf(c.toUpperCase()) !== -1);
        await fetch(`${root}cart/update.js`, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ discount: keep.join(',') }) });
        cart = await (await fetch(`${root}cart.js`, { credentials: 'same-origin', cache: 'no-store' })).json();
      }
      this.render(cart);
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'site-cart', data: { itemCount: cart.item_count } } }));
    } catch (err) {
      console.error('[site-cart]', err);
      row.classList.remove('is-busy');
      this.refresh();
    }
  }

  /* Subtotal antes de descuentos: lo que cuenta para el escalón (el regalo, lo que paga) */
  subtotal(cart = this.cart) {
    if (!cart || !Array.isArray(cart.items)) return 0;
    return cart.items.reduce((sum, item) => {
      const p = item.properties || {};
      return sum + (p._u1_gift || p._u1_flash_gift ? item.final_line_price : item.original_line_price);
    }, 0);
  }

  /* El escalón del subtotal; pos: avance dentro del escalón, proporcional al monto */
  tierInfo(cart = this.cart) {
    const count = cart ? cart.item_count : 0;
    const sub = this.subtotal(cart);
    if (!count || !this.tiers.length) return { pct: 0, idx: -1, next: this.tiers[0] || null, need: 0, frac: 0 };
    let idx = 0;
    this.tiers.forEach(([min], i) => { if (sub >= min) idx = i; });
    if (sub < this.tiers[0][0]) idx = -1;
    const next = this.tiers[idx + 1] || null;
    const from = idx < 0 ? 0 : this.tiers[idx][0];
    const frac = next ? Math.min(1, Math.max(0, (sub - from) / Math.max(next[0] - from, 1))) : 1;
    return { pct: idx < 0 ? 0 : this.tiers[idx][1], idx, next, need: next ? next[0] - sub : 0, frac };
  }

  money(cents) {
    const currency = (this.cart && this.cart.currency) || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try {
      return new Intl.NumberFormat((window.Shopify && window.Shopify.locale) || document.documentElement.lang || 'en', { style: 'currency', currency }).format(cents / 100);
    } catch (_) {
      return `${(cents / 100).toFixed(2)} ${currency}`;
    }
  }

  render(cart) {
    const prevPct = this.pct;
    this.cart = cart;
    const t = this.tierInfo(cart);
    const count = cart.item_count;
    const sub = this.subtotal(cart);
    this.pct = t.pct;
    this.classList.toggle('has-items', count > 0);
    this.classList.add('is-ready');
    if (this.pill) this.pill.classList.toggle('sc-has-items', count > 0);
    if (!this.plain) this.drawTop(t, sub, count, prevPct);

    /* productos (el vacío lo muestra el CSS con has-items) */
    const p = this.panel;
    const set = (sel, fn) => { const el = p.querySelector(sel); if (el) fn(el); };
    set('[data-sc-count]', el => { el.textContent = count; });
    set('[data-sc-lines]', el => { el.innerHTML = cart.items.map(item => this.lineHTML(item)).join(''); });

    /* resumen: el ahorro que aplicó Shopify; si todavía no hay ninguno, el estimado del escalón (sin escalera, ninguno:
       la fila se esconde) */
    const applied = Math.max(0, sub - cart.total_price);
    const estimated = !applied && t.pct > 0;
    const saving = applied || Math.round(sub * t.pct / 100);
    const total = applied ? cart.total_price : sub - saving;
    set('[data-sc-sub]', el => { el.textContent = this.money(sub); });
    set('[data-sc-save]', el => { el.textContent = this.money(saving); el.toggleAttribute('data-estimated', estimated); });
    set('[data-sc-save-row]', el => { el.hidden = this.plain && !saving; });
    set('[data-sc-total]', el => { el.textContent = this.money(total); });

    /* subió el escalón: el % salta y, con el carrito abierto, confetti */
    if (prevPct !== null && t.pct > prevPct) {
      [this.querySelector('[data-sc-badge]'), this.querySelector('[data-site-cart-off]')].forEach(b => {
        if (!b) return;
        b.classList.remove('is-bump');
        void b.offsetWidth;
        b.classList.add('is-bump');
      });
      this.celebrate();
    }
  }

  /* La franja cerrada, el encabezado y la escalera (no están sin escalera) */
  drawTop(t, sub, count, prevPct) {
    /* franja cerrada: solo el badge (la barra es la de la escalera) */
    const off = this.querySelector('[data-site-cart-off]');
    (off.querySelector('[data-sc-off-t]') || off).textContent = `- ${t.pct}%`;

    /* encabezado: lo desbloqueado + lo que falta para el próximo escalón y, con productos, para el envío gratis (o que
       ya lo tenés) */
    this.querySelector('[data-sc-badge]').textContent = `-${t.pct}%`;
    const msg = this.querySelector('[data-sc-msg]');
    const ship = count ? this.ship : 0;
    const shipped = ship > 0 && sub >= ship;
    const d = this.dataset;
    let html;
    if (!t.next) html = ship ? (shipped ? d.lMaxShipped : d.lMaxShip) : d.lMax;
    else html = (ship ? (shipped ? d.lAwayShipped : d.lAwayShip) : d.lAway).replace('{amount}', count ? esc(this.money(t.need)) : esc(d.lItem)).replace('{pct}', t.next[1]);
    msg.innerHTML = html.replace('{ship}', esc(this.money(Math.max(0, ship - sub))));

    /* escalera: los superados tachados; el actual con sus destellos; el envío gratis, alcanzado o con su monto */
    $$('.sc-cell:not([data-sc-ship])', this).forEach((el, i) => {
      el.classList.toggle('is-past', i < t.idx);
      el.classList.toggle('is-cur', i === t.idx);
      if (i === t.idx) el.append(this.fx());
    });
    if (t.idx < 0 && this._fx) this._fx.remove();
    const shipCell = this.querySelector('[data-sc-ship]');
    if (shipCell) {
      const was = shipCell.classList.contains('is-got');
      shipCell.classList.toggle('is-got', shipped);
      shipCell.querySelector('small').textContent = shipped ? d.lShip : this.money(this.ship).replace(/\.00$/, '');
      shipCell.setAttribute('aria-label', `${d.lShip}: ${this.money(this.ship)}`);
      if (shipped && !was && prevPct !== null) {
        shipCell.classList.remove('is-bump');
        void shipCell.offsetWidth;
        shipCell.classList.add('is-bump');
      }
    }
    /* el relleno llega al centro del último hito alcanzado y avanza hacia el próximo según el monto */
    const lad = this.ladder(sub, count);
    const fill = this.querySelector('[data-sc-fill]');
    fill.style.width = !count ? '0%' : !lad.done ? `calc(26px + ${(Math.max(lad.i, -.5) + .5 + lad.frac).toFixed(4)} * var(--sc-cell))` : '100%';
    this.scrollTrack(!this.open);
    this.updateFades();
  }

  lineHTML(item) {
    const img = item.featured_image && item.featured_image.url ? item.featured_image.url : item.image;
    const src = img ? `${img}${img.includes('?') ? '&' : '?'}width=240` : '';
    const opts = (item.options_with_values || []).filter(o => o.value && o.value !== 'Default Title').map(o => o.value);
    const props = Object.entries(item.properties || {}).filter(([k, v]) => v && !k.startsWith('_')).map(([k, v]) => `${k}: ${v}`);
    const desc = [...opts, ...props].join(' · ');
    const name = item.product_title || item.title;
    const p = item.properties || {};
    const gift = !!(p._u1_gift || p._u1_flash_gift);
    const free = gift && item.final_line_price === 0;
    return `<div class="sc-line" role="listitem" data-key="${esc(item.key)}" data-qty="${item.quantity}"${p._u1_bundle ? ` data-bundle="${esc(p._u1_bundle)}"` : ''}>` +
      `<span class="sc-line-img">${src ? `<img src="${esc(src)}" width="111" height="111" alt="" loading="lazy">` : ''}</span>` +
      `<div class="sc-line-info">` +
        `<div class="sc-line-hd"><p class="sc-line-t">${esc(name)}</p>${desc ? `<p class="sc-line-d">${esc(desc)}</p>` : ''}</div>` +
        `<p class="sc-line-p sc-amt${free ? ' sc-line-free' : ''}">${free ? esc(this.dataset.lFree) : esc(this.money(item.final_line_price))}</p>` +
        `<div class="sc-line-ctl">` +
          (gift ? '' : `<span class="sc-step"><button type="button" data-sc-q="-1" aria-label="${esc(this.dataset.lLess.replace('{name}', name))}"${item.quantity <= 1 ? ' disabled' : ''}>${MINUS}</button>` +
          `<span>${item.quantity}</span><button type="button" data-sc-q="1" aria-label="${esc(this.dataset.lMore.replace('{name}', name))}">${PLUS}</button></span>`) +
          `<button type="button" class="sc-line-del" data-sc-del aria-label="${esc(this.dataset.lRemove.replace('{name}', name))}">${TRASH}</button>` +
        `</div>` +
      `</div></div>`;
  }

  /* Con el carrito ya abierto, enseguida; si recién se está abriendo, cuando terminó de crecer */
  celebrate() {
    if (!this.confetti || reduce.matches) return;
    const wait = this.open ? Math.max(0, 1050 - (performance.now() - (this._openedAt || 0))) : 1050;
    clearTimeout(this._celebrateT);
    this._celebrateT = setTimeout(() => { if (this.open) this.confetti.burst(); }, wait);
  }

  /* Carrito vacío: una canasta de alambre vista desde arriba (del artifact). Tres aros en perspectiva; la grilla del
     fondo sube por las paredes hasta el borde */
  drawEmpty() {
    const box = this.querySelector('[data-sc-illu]');
    if (!box) return;
    const cx = 100, cy = 125, HX = 86, HY = 110, K = 1.3;
    const p = t => (1 - 1 / (1 + K * t)) / (1 - 1 / (1 + K));
    const sx = t => 1 - .44 * p(t), sy = t => 1 - .36 * p(t), rr = t => 13 - 6 * p(t);
    const P = (u, v, t) => [cx + u * HX * sx(t), cy + v * HY * sy(t)];
    const f = n => n.toFixed(2);
    const L = (a, b) => `M${f(a[0])} ${f(a[1])}L${f(b[0])} ${f(b[1])}`;
    const ring = (t, inset = 0) => {
      const w = HX * sx(t) - inset, h = HY * sy(t) - inset, r = rr(t) - inset * .5;
      return `<rect x="${f(cx - w)}" y="${f(cy - h)}" width="${f(2 * w)}" height="${f(2 * h)}" rx="${f(r)}"/>`;
    };
    const corner = (su, sv, t) => {
      const c = rr(t) * (1 - Math.SQRT1_2);
      return [cx + su * (HX * sx(t) - c), cy + sv * (HY * sy(t) - c)];
    };
    let d = '';
    for (let i = 1; i < 6; i++) {
      const u = -1 + 2 * i / 6;
      d += L(P(u, -1, 1), P(u, 1, 1)) + L(P(u, -1, 1), P(u, -1, 0)) + L(P(u, 1, 1), P(u, 1, 0));
    }
    for (let j = 1; j < 8; j++) {
      const v = -1 + 2 * j / 8;
      d += L(P(-1, v, 1), P(1, v, 1)) + L(P(-1, v, 1), P(-1, v, 0)) + L(P(1, v, 1), P(1, v, 0));
    }
    [[-1, -1], [1, -1], [1, 1], [-1, 1]].forEach(([a, b]) => { d += L(corner(a, b, 1), corner(a, b, 0)); });
    let hinge = '';
    [-1, 1].forEach(s => [-.44, .44].forEach(k => {
      const x = cx + s * HX, y = cy + k * HY;
      hinge += `M${f(x)} ${f(y - 9)}C${f(x + s * 7.5)} ${f(y - 9)} ${f(x + s * 7.5)} ${f(y + 9)} ${f(x)} ${f(y + 9)}`;
    }));
    const wires = `<path d="${d}"/>${ring(1)}${ring(.42)}`;
    const rim = `${ring(0)}${ring(0, 3.4)}<path d="${hinge}"/>`;
    const grips = [-1, 1].map(s => `<rect x="${cx - 50}" y="${f(cy + s * HY - 3.8)}" width="100" height="7.6" rx="3.8"/>`).join('');
    const id = `sc${Math.random().toString(36).slice(2, 7)}`;
    box.innerHTML = `<svg viewBox="-10 -8 220 266" aria-hidden="true"><defs>` +
      `<linearGradient id="${id}m" gradientUnits="userSpaceOnUse" x1="0" y1="0" x2="200" y2="250"><stop offset="0" stop-color="#a3a3a3"/><stop offset=".4" stop-color="#6c6c6c"/><stop offset=".68" stop-color="#ababab"/><stop offset="1" stop-color="#707070"/></linearGradient>` +
      `<linearGradient id="${id}g" x1="0" y1="0" x2="0" y2="1"><stop offset="0" stop-color="#eeeeee"/><stop offset="1" stop-color="#cdcdcd"/></linearGradient>` +
      `<filter id="${id}b" x="-10%" y="-10%" width="120%" height="120%"><feGaussianBlur stdDeviation="1.6"/></filter></defs>` +
      `<g transform="translate(2.4 4)" filter="url(#${id}b)" fill="none" stroke="#000" stroke-opacity=".12" stroke-width="1.8">${wires}${rim}</g>` +
      `<g fill="none" stroke="url(#${id}m)" stroke-linecap="round"><g stroke-width="1.6">${wires}</g><g stroke-width="2.6">${rim}</g></g>` +
      `<g fill="none" stroke="#fff" stroke-opacity=".75" stroke-width=".5" transform="translate(-.4 -.4)">${wires}${rim}</g>` +
      `<g fill="url(#${id}g)" stroke="#bdbdbd" stroke-width=".6">${grips}</g></svg>`;
  }
}

/* Confetti con física (receta confetti-burst del artifact): los papelitos caen sobre la pastilla del ahorro y rebotan */
function makeConfetti(stage, canvas, getTarget) {
  const ctx = canvas.getContext('2d');
  const COLORS = ['#ff4d67', '#ffb020', '#3b82f6', '#22c55e', '#a855f7', '#f97316', '#06b6d4', '#5a31f4'];
  const COUNT = 120, GRAVITY = 1300, SIZE = 8, SWAY = 16, BOUNCE = .3, HOLD = 1600, FADE = 600;
  let particles = [], running = false, lastT = 0, burstEnd = 0, fadeStart = null, W = 0, H = 0;
  function size() {
    const dpr = Math.min(window.devicePixelRatio || 1, 2);
    W = stage.offsetWidth; H = stage.offsetHeight;
    canvas.width = Math.round(W * dpr); canvas.height = Math.round(H * dpr);
    ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
  }
  /* la pastilla como píldora: techo plano entre los centros de las tapas, tapas circulares */
  function target() {
    const b = getTarget();
    if (!b || !b.offsetWidth) return null;
    const s = stage.getBoundingClientRect(), r = b.getBoundingClientRect();
    return { left: r.left - s.left, top: r.top - s.top, right: r.right - s.left, bottom: r.bottom - s.top };
  }
  function surface(x, b) {
    if (x < b.left || x > b.right) return null;
    const r = (b.bottom - b.top) / 2, lc = b.left + r, rc = b.right - r;
    if (x >= lc && x <= rc) return { y: b.top, slope: 0 };
    const c = x < lc ? lc : rc, dx = x - c, root2 = Math.sqrt(Math.max(r * r - dx * dx, 0));
    return { y: b.top + (r - root2), slope: dx / Math.max(root2, .001) };
  }
  function burst() {
    size();
    const now = performance.now(), spawn = 500;
    particles = [];
    fadeStart = null;
    for (let i = 0; i < COUNT; i++) {
      particles.push({
        start: now + Math.random() * spawn, x: Math.random() * W, y: -12 - Math.random() * 30, py: -12,
        vx: (Math.random() - .5) * 60, vy: 40 + Math.random() * 120,
        w: SIZE * (.7 + Math.random() * .6), h: SIZE * (.5 + Math.random() * .5), maxFall: 420 + Math.random() * 280,
        rot: Math.random() * Math.PI, vr: (Math.random() - .5) * 7, tumble: Math.random() * Math.PI * 2, tumbleSpeed: 4 + Math.random() * 8,
        squish: 1, phase: Math.random() * Math.PI * 2, swayFreq: 2 + Math.random() * 3, swayScale: .5 + Math.random(),
        color: COLORS[Math.floor(Math.random() * COLORS.length)], bounces: 0, resting: false, dead: false,
      });
    }
    burstEnd = now + spawn + 100;
    if (!running) { running = true; lastT = now; requestAnimationFrame(frame); }
  }
  function step(dt, now) {
    const b = target();
    for (const p of particles) {
      if (p.resting || p.dead || now < p.start) continue;
      p.py = p.y;
      p.vy = Math.min(p.vy + GRAVITY * dt, p.maxFall);
      p.phase += p.swayFreq * dt;
      p.x += (p.vx + Math.cos(p.phase) * SWAY * p.swayScale) * dt;
      p.y += p.vy * dt;
      p.rot += p.vr * dt;
      p.tumble += p.tumbleSpeed * dt;
      p.squish = .25 + .75 * Math.abs(Math.cos(p.tumble));
      const half = p.h / 2;
      if (b && p.vy > 0) {
        const s = surface(p.x, b);
        if (s && p.y + half >= s.y && p.py + half <= s.y + 2) {
          if (Math.abs(s.slope) > .85) {
            const dir = p.x < (b.left + b.right) / 2 ? -1 : 1;
            p.vx = dir * Math.max(Math.abs(p.vx), 50 + Math.random() * 50); p.vy *= .35; p.y = s.y - half;
          } else if (p.vy > 150 && p.bounces < 2) {
            p.bounces++; p.vy = -p.vy * BOUNCE * (.6 + Math.random() * .5); p.vx = p.vx * .7 + s.slope * 40 + (Math.random() - .5) * 40; p.y = s.y - half;
          } else { p.resting = true; p.y = s.y - half - .5; p.vx = 0; p.vy = 0; }
        }
      }
      if (!p.resting && p.y + half >= H - 1) {
        if (p.vy > 170 && p.bounces < 2) { p.bounces++; p.vy = -p.vy * BOUNCE * (.5 + Math.random() * .4); p.vx *= .7; p.y = H - 1 - half; }
        else { p.resting = true; p.y = H - 1 - half; p.vx = 0; p.vy = 0; }
      }
      if (p.x < -30 || p.x > W + 30 || p.y > H + 30) p.dead = true;
    }
  }
  function draw(alpha) {
    ctx.clearRect(0, 0, W, H);
    ctx.globalAlpha = alpha;
    const now = performance.now();
    for (const p of particles) {
      if (p.dead || now < p.start) continue;
      ctx.save(); ctx.translate(p.x, p.y); ctx.rotate(p.rot); ctx.scale(1, p.squish);
      ctx.fillStyle = p.color; ctx.fillRect(-p.w / 2, -p.h / 2, p.w, p.h);
      ctx.restore();
    }
    ctx.globalAlpha = 1;
  }
  /* la física avanza en pasos de ≤16ms aunque el frame venga demorado */
  function frame(now) {
    if (!running) return;
    let remaining = Math.min((now - lastT) / 1000, .25);
    lastT = now;
    while (remaining > 0) { const dt = Math.min(remaining, 1 / 60); step(dt, now); remaining -= dt; }
    if (fadeStart === null && now > burstEnd && particles.every(p => p.resting || p.dead)) fadeStart = now + HOLD;
    let alpha = 1;
    if (fadeStart !== null && now >= fadeStart) {
      alpha = 1 - (now - fadeStart) / FADE;
      if (alpha <= 0) { stop(); return; }
    }
    draw(alpha);
    requestAnimationFrame(frame);
  }
  /* si el carrito se cierra a mitad de la lluvia, los papelitos se van con él */
  function stop() { running = false; particles = []; ctx.clearRect(0, 0, W, H); }
  return { burst, stop };
}

if (!customElements.get('site-cart')) customElements.define('site-cart', SiteCart);
